import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import OrganizationsTable from "../components/OrganizationsTable";
import { ToastContainer } from 'react-toastify';

const OrganizationsActivePage = () => {
  return (
    <MasterLayout>
      <ToastContainer />
      <Breadcrumb title="Aktif" />
      <OrganizationsTable status="active" title="Aktif Organizasyonlar" />
    </MasterLayout>
  );
};

export default OrganizationsActivePage;

